"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TextAreaWeb = ({ placeholder, value, onChange, className = "", isDisabled = false }) => {
    const textareaRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (textareaRef.current != null) {
            textareaRef.current.style.height = "0px";
            const scrollHeight = textareaRef.current.scrollHeight;
            textareaRef.current.style.height = scrollHeight + "px";
        }
    }, [value]);
    return ((0, jsx_runtime_1.jsx)("textarea", { ref: textareaRef, value: value, className: className, placeholder: placeholder, onChange: event => onChange(event.target.value), disabled: isDisabled }));
};
exports.default = TextAreaWeb;
